/*global angular*/
var themePicker = angular.module('themePicker', []);
themePicker.directive('themePicker', ['$q', function ($q) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./themePicker.html'),
    replace: true,
    transclude: true,
    scope: {
      field: '=',
      theme: '='
    },
    //require: [ '^xyz' ], //requires a controller from the parent scope
    link: function (scope, element, attrs) {
      scope.themesCollums = function () {
        switch (scope.field.themes.length){
          case 3: case 5: case 6:
          return 'col-md-4';
          default:
            return 'col-md-3';
        }
      };

    }
  };
}]);
module.exports = themePicker;



// WEBPACK FOOTER //
// ./web/js/module/theme-picker/themePicker.js